import type { SVGProps } from 'react';

type IconProps = SVGProps<SVGSVGElement>;

const check = (p: IconProps) => (
  <svg viewBox="0 0 24 24" fill="none" {...p}>
    <path
      d="M5 13l4 4L19 7"
      stroke="currentColor"
      strokeWidth="2.4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const checkFill = (p: IconProps) => (
  <svg viewBox="0 0 24 24" fill="none" {...p}>
    <path
      d="M5.26789 10.732C4.29189 9.756 2.70889 9.756 1.73189 10.732C0.754887 11.708 0.755887 13.291 1.73189 14.268L6.37689 18.913C7.82589 20.362 10.1739 20.362 11.6229 18.913L12.5359 18L5.26789 10.732Z"
      fill="currentColor"
    />
    <path
      d="M22.268 4.732C21.292 3.756 19.709 3.756 18.732 4.732L9 14.464L12.536 18L22.268 8.268C23.244 7.291 23.244 5.708 22.268 4.732Z"
      fill="currentColor"
    />
  </svg>
);

const back = (p: IconProps) => (
  <svg viewBox="0 0 24 24" fill="none" {...p}>
    <path
      d="M15 5l-7 7 7 7"
      stroke="currentColor"
      strokeWidth="2.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const x = (p: IconProps) => (
  <svg viewBox="0 0 24 24" fill="none" {...p}>
    <path d="M6 6l12 12M18 6L6 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
  </svg>
);

const monitor = (p: IconProps) => (
  <svg viewBox="0 0 24 24" fill="none" {...p}>
    <rect x="3" y="4" width="18" height="13" rx="2" stroke="currentColor" strokeWidth="1.8" />
    <path d="M9 21h6M12 17v4" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
  </svg>
);

const smartphone = (p: IconProps) => (
  <svg viewBox="0 0 24 24" fill="none" {...p}>
    <rect x="7" y="3" width="10" height="18" rx="2.4" stroke="currentColor" strokeWidth="1.8" />
    <path d="M11 18h2" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
  </svg>
);

const chevL = (p: IconProps) => (
  <svg viewBox="0 0 24 24" fill="none" {...p}>
    <path
      d="M15 6l-6 6 6 6"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const chevR = (p: IconProps) => (
  <svg viewBox="0 0 24 24" fill="none" {...p}>
    <path
      d="M9 6l6 6-6 6"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const warning = (p: IconProps) => (
  <svg viewBox="0 0 24 24" fill="currentColor" {...p}>
    <circle cx="12" cy="12" r="10" opacity=".35" />
    <path d="M13.42,16.489c0,0.425-0.247,1.511-1.427,1.511s-1.412-1.086-1.412-1.511c0-0.415,0.263-1.529,1.412-1.529S13.42,16.074,13.42,16.489z M10.698,12.499V7.259c0-0.719,0.583-1.302,1.302-1.302h0c0.719,0,1.302,0.583,1.302,1.302v5.241c0,0.719-0.583,1.302-1.302,1.302h0C11.281,13.801,10.698,13.218,10.698,12.499z" />
  </svg>
);

const faq = (p: IconProps) => (
  <svg viewBox="0 0 24 24" fill="currentColor" {...p}>
    <path
      d="M12,2C6.477,2,2,6.477,2,12c0,1.592,0.382,3.091,1.043,4.427l-1.005,4.019c-0.229,0.915,0.6,1.745,1.516,1.516l4.019-1.005C8.909,21.618,10.408,22,12,22c5.523,0,10-4.477,10-10C22,6.477,17.523,2,12,2z"
      opacity=".35"
    />
    <path d="M11.883,13.973h-0.006c-0.67,0-1.187-0.605-1.072-1.265c0.35-2.013,1.917-2.083,1.917-3.333c0-0.347-0.06-1.124-0.896-1.124c-0.452,0-0.718,0.289-0.873,0.597c-0.209,0.417-0.691,0.622-1.15,0.541l0,0C9.107,9.265,8.68,8.519,8.975,7.877C9.397,6.96,10.261,6,11.972,6c2.776,0,3.148,2.174,3.148,3.196c0,2.416-1.799,2.506-2.172,3.898C12.813,13.596,12.403,13.973,11.883,13.973z M13.325,16.533c0,0.412-0.127,0.76-0.382,1.043C12.687,17.858,12.352,18,11.94,18c-0.414,0-0.748-0.142-1.003-0.424c-0.255-0.283-0.384-0.631-0.384-1.043c0-0.403,0.129-0.75,0.384-1.045c0.255-0.293,0.589-0.439,1.003-0.439c0.412,0,0.747,0.146,1.003,0.439C13.198,15.783,13.325,16.131,13.325,16.533z" />
  </svg>
);

export const RIcon = {
  check,
  checkFill,
  back,
  x,
  monitor,
  smartphone,
  chevL,
  chevR,
  warning,
  faq,
};
